import { UnitTypeMap } from './data';

export const UNITS: UnitTypeMap = {
  recurringDepositAmount: 'dollarsPerMonth',
  recurringWithdrawalAmount: 'dollarsPerMonth',
  oneTimeDepositAmount: 'dollars',
  targetDate: 'date',
};

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const MAXIMUM_GOAL_TERM_YEARS = 50;
